export const getSimpleArrayDiff = (arr1: (string | number)[], arr2: (string | number)[]) =>
  arr1.filter((x) => !arr2.includes(x)).concat(arr2.filter((x) => !arr1.includes(x)))
